// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__I4URY","footer":"ModalFilter_footer__3MFbr"};